function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff"
    },
    fillRule: "evenodd",
    d: "M14.142 1.192a.734.734 0 0 0-1.059 0 .77.77 0 0 0 0 1.066l5.368 5.465H.741a.745.745 0 0 0-.742.755c0 .42.329.766.742.766h17.71l-5.368 5.454a.783.783 0 0 0 0 1.077.732.732 0 0 0 1.059 0l6.636-6.758a.747.747 0 0 0 0-1.066l-6.636-6.759z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f6ba0a0018aa51804615de2c7e35fa6e.svg";
export { ForwardRef as ReactComponent };